import { Token } from '@shared/types';

let lastInjectedTokens = '';
const rootSelector = ':root';
const dynamicAttr = 'data-dynamic-css';

const flattenTokens = (
	obj: Token,
	prefix = '',
	result: Record<string, string> = {},
) => {
	for (const key in obj) {
		const value = obj[key as keyof typeof obj];
		const newKey = `${prefix}${key}`;
		if (typeof value === 'object' && value !== null) {
			flattenTokens(value as unknown as Token, `${newKey}-`, result);
		} else {
			result[`--${newKey}`] = value;
		}
	}
	return result;
};

const generateCSSVariables = (tokens: Token) => {
	return flattenTokens(tokens);
};

const injectCssTokens = (customTokens: Token) => {
	const tokenKey = JSON.stringify(customTokens);

	if (lastInjectedTokens === tokenKey) {
		return;
	}

	const cssVariables = generateCSSVariables(customTokens);

	let styleElement = document.querySelector(`style[${dynamicAttr}]`);
	if (!styleElement) {
		styleElement = document.createElement('style');
		styleElement.setAttribute(dynamicAttr, 'true');
		document.head.appendChild(styleElement);
	}

	const cssContent = Object.entries(cssVariables)
		.map(([property, value]) => `${property}: ${value};`)
		.join('\n');

	styleElement.textContent = `
        ${rootSelector} {
            ${cssContent}
        }
    `;

	lastInjectedTokens = tokenKey;
};

const removeCssTokens = () => {
	const styleElement = document.querySelector(`style[${dynamicAttr}]`);

	if (!styleElement) {
		return;
	}

	styleElement.remove();
	lastInjectedTokens = '';
};

export { generateCSSVariables, injectCssTokens, removeCssTokens };
